import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { toEuros } from 'i18n';
import { SquareButton } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  line: {
    ...theme.fonts.caption,
    color: theme.colors.inkPrimary,
  },
  title: {
    ...theme.fonts.label,
    textAlign: 'left',
  },
  price: {
    ...theme.fonts.caption,
  },
  error: {
    ...theme.fonts.caption,

    color: theme.colors.redAccessible,
  },
  buttons: {
    textAlign: 'center',
  },
  total: {
    ...theme.fonts.caption,
  },
}));

interface Props {
  title?: string;
  unitPrice?: number;
  quantity?: number;
  compareToQuantity?: number;
  total?: number;
  compareToTotal?: number;
  onAddClick?: () => any;
  onRemoveClick?: () => any;
}

export const BillingCardLine = ({
  title,
  unitPrice,
  quantity,
  compareToQuantity,
  total,
  compareToTotal,
  onAddClick,
  onRemoveClick,
}: Props) => {
  const classes = useStyles();

  return (
    <tr className={classes.line}>
      <td className={classes.title}>{title}</td>
      <td className={classes.price}>
        {unitPrice !== undefined && toEuros(unitPrice)}
      </td>
      <td className={classes.price}>
        {quantity}
        {compareToQuantity !== undefined && compareToQuantity !== quantity ? (
          <span className={classes.error}> / {compareToQuantity}</span>
        ) : null}
      </td>
      <td className={classes.price}>
        {total !== undefined && toEuros(total)}
        {compareToTotal !== undefined && total !== compareToTotal ? (
          <div className={classes.error}>{toEuros(compareToTotal)}</div>
        ) : null}
      </td>
      <td className={classes.buttons}>
        {onRemoveClick && (
          <SquareButton
            icon="ri-delete-bin-line"
            color="red"
            small
            variant="transparent"
            onClick={onRemoveClick}
          />
        )}
        {onAddClick && (
          <SquareButton
            icon="ri-add-line"
            color="green"
            small
            variant="transparent"
            onClick={onAddClick}
          />
        )}
      </td>
    </tr>
  );
};
